import type { GetStaticProps } from 'next';
import { fetchBlogPosts } from '../../utils/api/fetchStrapiData';
import { UiUxPage } from '../../views/uiUxPage/UiUxPage';

export const getStaticProps: GetStaticProps = async () => {
  const data = await fetchBlogPosts();
  return {
    props: { blogPosts: data },
  };
};

export default UiUxPage;
